import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Check, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Seo } from "@/components/Seo";
import { useLang } from "@/context/LanguageContext";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const { lang } = useLang();
  const fr = lang === "fr";
  const sid = params.get("session_id");
  const [state, setState] = useState("checking"); // checking | paid | pending | error
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!sid) { setState("error"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        setInfo(data);
        if (data.payment_status === "paid") { setState("paid"); return; }
        if (attempts++ < 6) setTimeout(poll, 2000);
        else setState("pending");
      } catch { setState("error"); }
    };
    poll();
  }, [sid]);

  return (
    <>
      <Seo title={fr ? "Confirmation" : "Confirmation"} description="" path="/payment/success" />
      <div className="min-h-[80svh] flex items-center justify-center px-5 pt-24 pb-20">
        <div className="max-w-lg text-center" data-testid="payment-success">
          {state === "checking" && (<><Loader2 className="mx-auto animate-spin text-gold" size={40} /><p className="mt-6 text-ink/60">{fr ? "Vérification du paiement…" : "Verifying payment…"}</p></>)}
          {state === "paid" && (
            <>
              <div className="mx-auto w-16 h-16 border border-gold flex items-center justify-center"><Check className="text-gold" size={30} /></div>
              <p className="overline text-gold mt-8 mb-4">{fr ? "Réservation confirmée" : "Booking confirmed"}</p>
              <h1 className="font-serif text-4xl sm:text-5xl leading-tight">{info?.listing_name}</h1>
              <p className="mt-6 text-ink/70">{fr ? "Du" : "From"} {info?.check_in} {fr ? "au" : "to"} {info?.check_out} · {info?.nights} {fr ? "nuits" : "nights"}</p>
              <p className="font-serif text-3xl mt-2">{info?.amount} €</p>
              <p className="mt-6 text-ink/60 text-sm">{fr ? "Merci ! Un email de confirmation vous parviendra prochainement." : "Thank you! A confirmation email will follow shortly."}</p>
              <Link to="/collection" className="inline-block mt-10 bg-ink text-ivory px-8 py-4 overline hover:bg-gold hover:text-ink transition-colors" data-testid="back-collection">{fr ? "Retour à la Collection" : "Back to the Collection"}</Link>
            </>
          )}
          {state === "pending" && (<><p className="overline text-ink/50 mb-4">{fr ? "Paiement en cours" : "Payment processing"}</p><p className="text-ink/70">{fr ? "Votre paiement est en cours de traitement. Vous recevrez une confirmation sous peu." : "Your payment is being processed. You will receive a confirmation shortly."}</p></>)}
          {state === "error" && (<><h1 className="font-serif text-3xl">{fr ? "Session introuvable" : "Session not found"}</h1><Link to="/collection" className="overline inline-block mt-6 border-b border-ink pb-1">{fr ? "Retour à la Collection" : "Back to the Collection"}</Link></>)}
        </div>
      </div>
    </>
  );
}
